import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { Trans } from "react-i18next";

interface ScrollAnimatedSectionProps {
  text: string;
  className?: string;
  image?: string;
  style?: React.CSSProperties;
}

const ScrollAnimatedSection: React.FC<ScrollAnimatedSectionProps> = ({ text, className, image, style }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      className={className}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={style}
    >
      <Trans i18nKey={text}></Trans>
      {image && (
        <img src={image} alt=""
        style={{
          width: "clamp(150px, 40vw, 300px)", // 🔧 responsive size
          height: "auto",
          display: "block"
        }}
        />
        )}
    </motion.div>
  );
};

export default ScrollAnimatedSection;
